
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import store from './app/store';
import App from './App';
import './styles/App.css';
import React from 'react';

const container = document.getElementById('root');
const root = ReactDOM.createRoot(container!);

const nonce = document
  .querySelector("meta[name='csp-nonce']")
  ?.getAttribute("content") || "";


root.render(
   <React.StrictMode>
  <Provider store={store}>
    <App nonce={nonce}/>
  </Provider>
   </React.StrictMode>
);